module.exports = __webpack_public_path__ + "img/my-revenue-picture-img.5d47b2ac.png";